'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgShoppingBasket } from '@common/icon';
import { cn } from '@core/utils';
import { GiftListItem } from '@/app/donation/_components/GiftListItem';
export interface RecommendedGiftCardProps {
  productNumber: string;
  imageUrl?: string;
  title: string;
  donationAmount: number;
  reviewRating: number;
  reviewCount: number;
  institution?: {
    id: number;
    logoUrl: string;
    name: string;
  };
  isAdult?: boolean;
  onAddToCart?: () => void;
  className?: string;
}
export const RecommendedGiftCard = t0 => {
  const $ = _c(18);
  const {
    productNumber,
    imageUrl,
    title,
    donationAmount,
    reviewRating,
    reviewCount,
    institution,
    isAdult,
    onAddToCart,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col justify-between", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = imageUrl ?? "";
  let t3;
  if ($[2] !== donationAmount || $[3] !== institution || $[4] !== isAdult || $[5] !== productNumber || $[6] !== reviewCount || $[7] !== reviewRating || $[8] !== t2 || $[9] !== title) {
    t3 = <GiftListItem mainImageUrl={t2} title={title} donationAmount={donationAmount} reviewRating={reviewRating} reviewCount={reviewCount} productNumber={productNumber} institution={institution} isAdult={isAdult} />;
    $[2] = donationAmount;
    $[3] = institution;
    $[4] = isAdult;
    $[5] = productNumber;
    $[6] = reviewCount;
    $[7] = reviewRating;
    $[8] = t2;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgShoppingBasket className="size-16 text-Gray-600" />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onAddToCart) {
    t5 = <Button dimensions="H40" theme="sub-line" onClick={onAddToCart} className="mt-12 w-full bg-Gray-white mobile-tablet:bg-transparent">{t4} 담기</Button>;
    $[12] = onAddToCart;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t3 || $[16] !== t5) {
    t6 = <div className={t1}>{t3}{t5}</div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};